const backendUri = process.env.REACT_APP_API_SERVER;
export const LOGIKA_URL_DATA = `${backendUri}/api/logica/parse/`;

export const DATATYPES = ['FT110', '@B', 'Всі'];

export const dateToUpload = (dateToFormat) => {
  const dateArr = dateToFormat.split('.');
  const dateDay = dateArr[0];
  const dateMonth = dateArr[1];
  const dateYear = dateArr[2];
  const formatedDate = `${dateYear}-${dateMonth}-${dateDay}`;
  return formatedDate;
};

export function getDateStr(v) {
  if (v) {
    const cd = new Date(v);
    return cd.toLocaleString('uk', { year: 'numeric', month: 'numeric', day: 'numeric' });
  }
  return null;
}
